import { atom } from 'jotai';

export const metricsAtom = atom<string[]>([]);
